import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      timelineItems: (state) => state.dashboard.timelineItems,
    }),
  },
  methods: {
    validateCtaExists(ctaId) {
      const timelineItem = this.timelineItems.find(
        (item) => item.data && item.data.id === ctaId
      )

      if (!timelineItem) {
        this.$router.replace({
          name: 'VideoPage',
          params: { id: this.$route.params.id },
        })
        return false
      }
      return true
    },
  },
  created() {
    // Validar se o CTA existe na timeline
    const ctaId =
      this.$route.params.quizId ||
      this.$route.params.formId ||
      this.$route.params.btnId
    if (ctaId) {
      this.validateCtaExists(ctaId)
    }
  },
  beforeRouteUpdate(to, from, next) {
    // Validar quando a rota muda mas o componente é reutilizado
    const ctaId = to.params.quizId || to.params.formId || to.params.btnId
    if (ctaId && !this.validateCtaExists(ctaId)) {
      return
    }
    next()
  },
}
